<template>
    <div>
      <section id="about-area" :style="'background-position:50% 50%;'">
        <div class="contents">
            <div class="container">
                <div class="contents-main">
                    <h2 class="wow fadeInDown media-txt animated" data-wow-duration="1000ms" data-wow-delay="0.3s" style="visibility: visible;-webkit-animation-duration: 1000ms; -moz-animation-duration: 1000ms; animation-duration: 1000ms;-webkit-animation-delay: 0.3s; -moz-animation-delay: 0.3s; animation-delay: 0.3s;">旺翔数科：汇聚全球·助力营销</h2>
                    <h2 class="wow fadeInUp bot-txt animated" data-wow-duration="1000ms" data-wow-delay="400ms" style="visibility: visible;-webkit-animation-duration: 1000ms; -moz-animation-duration: 1000ms; animation-duration: 1000ms;-webkit-animation-delay: 400ms; -moz-animation-delay: 400ms; animation-delay: 400ms;">ADunite：Connecting Global Competence·Boosting Marketing Influence</h2>
                </div>
            </div>
        </div>
      </section>
      <section id="about-main" class="about-sec1">
        <div class="container">
            <div class="row">
                <div class="toggle-tabb">
                <div class="tabs">
                    <div class="tab" :class="{active:num == 1}" id="tab-a" @click="toNum(1)">公司介绍</div>
                    <div class="tab" :class="{active:num == 2}" id="tab-b" @click="toNum(2)">合作伙伴</div>
                    <div class="tab" :class="{active:num == 3}" id="tab-c" @click="toNum(3)">发展历程</div>
                    <div class="tab" :class="{active:num == 4}" id="tab-d" @click="toNum(4)">荣誉资质</div>
                    <!-- <div class="tab" :class="{active:num == 5}" id="tab-e" @click="toNum(5)">投资者管理关系</div> -->
                </div>
                <div class="panels">
                    <div class="panel" v-show="num == 1">
                        <div class="about-head">
                            <h2>关于旺翔</h2>
                            <div class="a-h-info">
                                <p>上海旺翔数字科技股份有限公司（股票代码：835063）是一家集DSP、SSP、DMP、游戏、网盟，产品研发，海外流量业务的综合性移动数字营销广告传媒公司，于2015年挂牌新三板，专注移动数字营销广告领域7年。从2011年成立起，旺翔数科一直致力于移动数字营销广告事业，并不断延伸业务范围。于2016年与APUS达成战略合作，正式进军海外市场。目前，公司具有深度的海量国内外流量资源聚合能力，聚集三十大平台，12亿用户，22000家广告主，2.5亿日活，业务覆盖100个国家及地区。</p>
                                <p>公司致力于研发领先的互联网技术，创新开发三大技术引擎：超大数据运算引擎，深度SDK定制引擎，智能场景匹配引擎。精准定向广告投放，提升广告营销效果，采用多种创新的网络广告技术使广告投放精准化、媒体利益最大化。公司秉承“汇聚全球·助力营销”的经营理念，始终坚守“成就、责任、合作、忠诚、创新”的文化理念和价值体系，带领公司走向平台化的发展道路。总部上海，在北京、深圳、香港设有分公司。战略合作覆盖百度，阿里，腾讯等超一流互联网企业，客户覆盖阿里、京东、苏宁、唯品会、   1号店、平安、招商银行等。</p>
                            </div>
                        </div>
                        <div class="owner-section">
                            <h2>管理团队</h2>
                            <div class="o-s-main">
                                <div class="o-s-content ceo">
                                    <img src="../../assets/img/about/ceo.png" alt="image of ceo">
                                    <h2>王正旺</h2>
                                    <h3>董事长</h3>
                                    <p>旺翔数科联合创始人/复旦大学EMBA。江苏TMT新三板杰出董事长，荣获中国当代杰出…</p>
                                    <button type="button" class="tabb-btn" @click="toSee(1)">查看更多</button>
                                    <!-- <a href="#about-pop1" class="tabb-btn" data-lity=""><span>查看更多</span></a> -->
                                </div>
                                <div class="o-s-content vpone">
                                    <img src="../../assets/img/about/vpone.png" alt="image of vice president">
                                    <h2>邓永瑞/VP</h2>
                                    <h3>副总裁</h3>
                                    <p>美国纽约理工学院MBA。八年以上互联网领域营销相关工作，擅长整合海外资源、带…</p>
                                    <button type="button" class="tabb-btn" @click="toSee(2)">查看更多</button>
                                    <!-- <a href="#about-pop2" class="tabb-btn" data-lity=""><span>查看更多</span></a> -->
                                </div>
                                <div class="o-s-content vptwo">
                                    <img src="../../assets/img/about/vptwo.png" alt="image of vice president">
                                    <h2>孙健/VP</h2>
                                    <h3>副总裁</h3>
                                    <p>旺翔数科联合创始人。拥有多年移动互联网媒介、营销经验和丰富的媒体资源与百度、…</p>
                                    <button type="button" class="tabb-btn" @click="toSee(3)">查看更多</button>
                                    <!-- <a href="#about-pop3" class="tabb-btn" data-lity=""><span>查看更多</span></a> -->
                                </div>				    		
                            </div>
                        </div>
                        <!-- about pop up hidden section -->
                        
                        <!-- <div class="modal " id="about-pop1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-body">
                                        <div class="about-pop-main">
                                            <img src="../../assets/img/about/ceo.png" alt="image of ceo">
                                            <div class="about-pop-info">
                                                <h2>王正旺/CEO</h2>
                                                <h3>董事长</h3>
                                                <p>旺翔数科联合创始人/复旦大学EMBA<br>江苏TMT新三板杰出董事长，荣获中国当代杰出广告人称号，2017中国新三板公司年度人物。上海市青年企业家、青联协会会员、资深互联网行业专家、战略执行领导力开展家。拥有10年实战经验，在行内拥有良好的口碑。</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div id="about-pop1" style="background: rgb(255, 255, 255); max-height: 969px;" class="lity-hide">
                            <div class="about-pop-main">
                                <img src="../../assets/img/about/ceo.png" alt="image of ceo">
                                <div class="about-pop-info">
                                    <h2>王正旺/CEO</h2>
                                    <h3>董事长</h3>
                                    <p>旺翔数科联合创始人/复旦大学EMBA<br>江苏TMT新三板杰出董事长，荣获中国当代杰出广告人称号，2017中国新三板公司年度人物。上海市青年企业家、青联协会会员、资深互联网行业专家、战略执行领导力开展家。拥有10年实战经验，在行内拥有良好的口碑。</p>
                                </div>
                            </div>
                        </div>
                        <div id="about-pop2" style="background: rgb(255, 255, 255); max-height: 969px;" class="lity-hide">
                            <div class="about-pop-main">
                                <img src="../../assets/img/about/vpone.png" alt="image of vice president">
                                <div class="about-pop-info">
                                    <h2>邓永瑞/VP</h2>
                                    <h3>副总裁</h3>
                                    <p>美国纽约理工学院MBA<br>八年以上互联网领域营销相关工作，擅长整合海外资源、带领团队进行全球化大数据精准营销。<br>原上海联创国际广告公司SSM<br>原上海摩威电子科技有限公司MD</p>
                                </div>
                            </div>
                        </div>
                        <div id="about-pop3" style="background: rgb(255, 255, 255); max-height: 969px;" class="lity-hide">
                            <div class="about-pop-main">
                                <img src="../../assets/img/about/vptwo.png" alt="image of vice president">
                                <div class="about-pop-info">
                                    <h2>孙健/VP</h2>
                                    <h3>副总裁</h3>
                                    <p>旺翔数科联合创始人<br>拥有多年移动互联网媒介、营销经验和丰富的媒体资源与百度、腾讯、今日头条等知名媒体保持良好的合作关系。<br> 精通CPM、CPA等模式合作方式。</p>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div id="about-pop4" style="background:#fff" class="lity-hide">
                            <div class="about-pop-main">
                                <img src="../../assets/img/about/cto.png" alt="image of cto">
                                <div class="about-pop-info">
                                    <h2>黄元武/CTO</h2>
                                    <h3>技术总监</h3>
                                    <p>15年技术研发和管理经验<br>曾就职第一视频、北京金通、上海轻问<br>国内最早一批从事CDN网络视频广告人之一<br> 擅长大流量、大访问量、高负载的互联网/无线互联网系统架构</p>
                                </div>
                            </div>
                        </div> -->
                        <div class="about-contact">
                            <h2>联系旺翔</h2>
                            <div class="contact-address">
                                <p>地址: 上海市普陀区中江路879弄（天地软件园）3幢303</p>
                                <p>地铁: 13号线大渡河路站4号口</p>
                                <p>上海旺翔数字科技股份有限公司</p>
                                <p>Shanghai Wang Xiang Digital Technology Co., Ltd</p>
                                <p>股票代码: 835063</p>
                                <p>联系电话: 400-8160-569</p>
                                <p>联系邮箱: Info@adunite.com</p>
                            </div>
                        </div>
                    </div>
                    <div class="panel" v-show="num == 2">
                        <div class="partners">
                            <h2 class="partners-head">客户需求至上，为媒体主实现收益，与代理公司相辅相成通力合作，忠实信赖第三方机构。旺翔数科始终致力于与互联网广告各方知名企业互换优质资源、实现友好合作共赢。</h2>
                            <div class="partners-info">
                                <ul>
                                    <li><img src="../../assets/img/partners/partner1.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner2.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner3.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner4.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner5.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner6.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner7.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner8.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner9.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner10.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner11.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner12.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner13.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner14.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner15.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner16.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner17.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner18.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner19.png" alt="partners"></li>
                                    <li><img src="../../assets/img/partners/partner20.png" alt="partners"></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="panel" v-show="num == 3">
                        <div class="history">
                            <div class="history-point">
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2019</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-q">01月</h2><h2 class="h-i-a">· 荣获金鼠标数字营销两项大奖</h2></div>
                                </div>
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2018</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-q">12月</h2><h2>· 荣获2018DMAA中国数字营销大赛两项大奖</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-uniq">· 荣获普陀区“瞪羚企业”称号</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mtwo">04月</h2><h2>· 财富传媒集团签署战略合作协议，共同打造全媒体生态链</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mthree">03月</h2><h2>· 荣获“百度原生广告优秀创意代理商”、“百度FY2017代理商成长奖”</h2></div>
                                </div>		
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2017</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-q">12月</h2><h2 class="lin-hgt">· 公司将”数字广告惊魂营销及海外移动分发平台“作为申报项目，经过2017年普陀区文化发展专项资金申报、评审等程序，成功获得2017年普陀区文化发展专项资金</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mthree">10月</h2><h2>· 公司成为上海市工商联会员</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q">6月</h2><h2>· 旺翔数科凭借在互联网广告领域的领先地位，基于未来点播影院的广告投放，与1905（北京）网络有限公司签署《战略合作协议》</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-uniq">· 公司荣获2015-2016“上海市守合同重信用企业”奖和AAA级合同信用等级证书“</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mthree">5月</h2><h2>· 创新层维层成功</h2></div>
                                </div>		
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2016</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-q">6月</h2><h2 class="lin-hgt">· 公司进入新三板创新层，全年营收额突破2.5亿</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mthree">4月</h2><h2>· 与APUS达成战略合作，正式进军海外市场</h2></div>
                                </div>		
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2015</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-q">12月</h2><h2 class="lin-hgt">· 挂牌新三板</h2></div>
                                    <div class="h-i-wrap"><h2 class="h-i-q mthree">1月</h2><h2>· 获联创A轮投资</h2></div>
                                </div>		
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2013</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-uniq">· 营业额突破千万，先后获得10项技术著作权</h2></div>
                                </div>		
                            </div>
                            <div class="history-info">
                                <div class="h-i-left">
                                    <div class="border-outer">
                                        <div class="border-inner">
                                        </div>
                                    </div>
                                    <h2>2011</h2>
                                </div>
                                <div class="h-i-right">
                                    <div class="h-i-wrap"><h2 class="h-i-uniq">· 公司成立</h2></div>
                                </div>		
                            </div>
                        </div>
                    </div>
                    <div class="panel" v-show="num == 4">
                        <div class="honor">
                            <div class="honor-content">
                                <h2>2019</h2>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award1.png" alt="Awards">
                                    <p>金属标10周年·特别奖</p>
                                </div>
                            </div>
                            <div class="honor-content">
                                <h2>2018</h2>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award2.png" alt="Awards">
                                    <p>普陀区瞪羚企业</p>
                                </div>
                                <div class="h-c-inner award-one">
                                    <img src="../../assets/img/awards/award3.png" alt="Awards">
                                    <p>年度最佳数字营销公司</p>
                                </div>
                                <div class="h-c-inner award-two">
                                    <img src="../../assets/img/awards/award4.png" alt="Awards">
                                    <p>“瞪羚企业”荣誉证书</p>
                                </div>
                                <div class="h-c-inner award-three">
                                    <img src="../../assets/img/awards/award5.png" alt="Awards">
                                    <p>2018年度优秀企业</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award6.png" alt="Awards">
                                    <p>上海市“专精特新”企业</p>
                                </div>
                                <div class="h-c-inner award-four">
                                    <img src="../../assets/img/awards/award7.png" alt="Awards">
                                    <p>软件产品证书</p>
                                </div>
                            </div>
                            <div class="honor-content">
                                <h2>2017</h2>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award8.png" alt="Awards">
                                    <p>上海市“专精特新”企业名单</p>
                                </div>
                                <div class="h-c-inner award-five">
                                    <img src="../../assets/img/awards/award9.png" alt="Awards">
                                    <p>新三板新锐品牌</p>
                                </div>
                                <div class="h-c-inner award-six">
                                    <img src="../../assets/img/awards/award10.png" alt="Awards">
                                    <p>中国当代杰出广告人</p>
                                </div>
                                <div class="h-c-inner award-seven">
                                    <img src="../../assets/img/awards/award11.png" alt="Awards">
                                    <p>新三板年度优秀企业</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award12.png" alt="Awards">
                                    <p>新三板金鲨鱼奖</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award13.png" alt="Awards">
                                    <p>“AAA”合同信用等级认定证书</p>
                                </div>
                                <div class="h-c-inner award-eight">
                                    <img src="../../assets/img/awards/award14.png" alt="Awards">
                                    <p>新三板公司年度人物</p>
                                </div>
                                <div class="h-c-inner award-nine">
                                    <img src="../../assets/img/awards/award15.png" alt="Awards">
                                    <p>上海市工联、总商会员证</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award16.png" alt="Awards">
                                    <p>代理商成长奖</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award17.png" alt="Awards">
                                    <p>优秀创意代理商</p>
                                </div>
                                <div class="h-c-inner award-ten">
                                    <img src="../../assets/img/awards/award18.png" alt="Awards">
                                    <p>中国最具投资价值新三板公司</p>
                                </div>
                                <div class="h-c-inner award-eleven">
                                    <img src="../../assets/img/awards/award19.png" alt="Awards">
                                    <p>新三板公司年度人物</p>
                                </div>
                            </div>
                            <div class="honor-content">
                                <h2>2016</h2>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award20.png" alt="Awards">
                                    <p>新三板挂牌鼓励奖</p>
                                </div>
                                <div class="h-c-inner">
                                    <img src="../../assets/img/awards/award21.png" alt="Awards">
                                    <p>新三板年终“杰出董事长”</p>
                                </div>
                                <div class="h-c-inner award-twelve">
                                    <img src="../../assets/img/awards/award22.png" alt="Awards">
                                    <p>新三板最具成长性公司</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel" v-show="num == 5">
                        <div id="idData" class="i-m-relation" ref="tt">

                            <div class="i-m-content newsNavF" v-for="(item,index) in list" :key="index" :class="{displayNone:Math.ceil((index+ 1)/10) != num1}">
                                <a target="_blank" :href="item.pdf">
                                    <div class="i-m-left">
                                        <p>{{ item.title }}</p>
                                    </div>
                                    <div class="i-m-right">
                                        <h3>{{ item.time }}</h3>
                                    </div>
                                </a>
                            </div>

                        </div>
                        <el-pagination
                            style="margin-top: 50px;text-align: center;"
                            background
                            @current-change="currentChange"
                            layout="prev, pager, next"
                            :pager-count="5"
                            :page-size="10"
                            :total="list.length">
                        </el-pagination>
                        <!-- <div class="pageBox" style="margin-top: 110px;margin-bottom: 50px;text-align: center;"><span style="color:#787878;">首页</span><span style="margin-left: 20px;color:#787878;">上一页</span><strong style="margin-left: 20px"><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: inline;" href="javascript:void(0);" onclick="goPage(1,9,'idData')" class="pcon cur">1</a><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: inline;" href="javascript:void(0);" onclick="goPage(2,9,'idData')" class="pcon">2</a><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: inline;" href="javascript:void(0);" onclick="goPage(3,9,'idData')" class="pcon">3</a><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: inline;" href="javascript:void(0);" onclick="goPage(4,9,'idData')" class="pcon">4</a><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: inline;" href="javascript:void(0);" onclick="goPage(5,9,'idData')" class="pcon">5</a><a style="margin-right: 20px; padding: 8px 12px; color: rgb(51, 51, 51); font-size: 14px; box-shadow: rgba(109, 133, 245, 0.3) 0px 0px 4px 0px; background: rgb(255, 255, 255); border-radius: 4px; display: none;" href="javascript:void(0);" onclick="goPage(6,9,'idData')" class="pcon">6</a></strong><a style="margin-left: 0px;color:#787878;" href="javascript:void(0);" onclick="goPage(2,9,'idData')">下一页</a><a style="margin-left: 20px;color:#787878;" href="javascript:void(0);" onclick="goPage(6,9,'idData')">尾页</a><span style="margin-left: 20px;color:#787878;">共6页</span></div> -->
                    </div>
                </div>
                </div>
            </div>
        </div>
    </section>
    <el-dialog :visible="dialogVisible" :show-close="false" :before-close="handleClose">
        <div class="about-pop-main">
            <img src="../../assets/img/about/ceo.png" alt="image of ceo">
            <div class="about-pop-info">
                <h2>王正旺/CEO</h2>
                <h3>董事长</h3>
                <p>旺翔数科联合创始人/复旦大学EMBA<br>江苏TMT新三板杰出董事长，荣获中国当代杰出广告人称号，2017中国新三板公司年度人物。上海市青年企业家、青联协会会员、资深互联网行业专家、战略执行领导力开展家。拥有10年实战经验，在行内拥有良好的口碑。</p>
            </div>
        </div>
    </el-dialog>
    <el-dialog :visible="dialogVisible1" :show-close="false" :before-close="handleClose">
        <div class="about-pop-main">
            <img src="../../assets/img/about/vpone.png" alt="image of vice president">
            <div class="about-pop-info">
                <h2>邓永瑞/VP</h2>
                <h3>副总裁</h3>
                <p>美国纽约理工学院MBA<br>八年以上互联网领域营销相关工作，擅长整合海外资源、带领团队进行全球化大数据精准营销。<br>原上海联创国际广告公司SSM<br>原上海摩威电子科技有限公司MD</p>
            </div>
        </div>
    </el-dialog>
    <el-dialog :visible="dialogVisible2" :show-close="false" :before-close="handleClose">
        <div class="about-pop-main">
            <img src="../../assets/img/about/vptwo.png" alt="image of vice president">
            <div class="about-pop-info">
                <h2>孙健/VP</h2>
                <h3>副总裁</h3>
                <p>旺翔数科联合创始人<br>拥有多年移动互联网媒介、营销经验和丰富的媒体资源与百度、腾讯、今日头条等知名媒体保持良好的合作关系。<br> 精通CPM、CPA等模式合作方式。</p>
            </div>
        </div>
    </el-dialog>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        dialogVisible:false,
        dialogVisible1:false,
        dialogVisible2:false,
        num1:1,
        num:1,
        list:[
            {"title":"[临时公告]旺翔数科:关联交易公告","time":"2018-05-24","pdf":"./report/20180524-2.pdf"},{"title":"[临时公告]旺翔数科:第一届董事会第二十五次会议决议公告","time":"2018-05-24","pdf":"./report/20180524.pdf"},{"title":"[临时公告]旺翔数科:关联交易公告","time":"2018-05-18","pdf":"./report/20180518-2.pdf"},{"title":"[临时公告]旺翔数科:第一届董事会第二十四次会议决议公告","time":"2018-05-18","pdf":"./report/20180518.pdf"},{"title":"[临时公告]旺翔数科:公司章程","time":"2018-05-08","pdf":"./report/20180508-1.pdf"},{"title":"[临时公告]旺翔数科:2017年年度股东大会决议公告","time":"2018-05-08","pdf":"./report/20180508.pdf"},{"title":"[临时公告]旺翔数科:2018年第一次临时股东大会决议","time":"2018-04-27","pdf":"./report/20180427.pdf"},{"title":"[临时公告]旺翔数科:2018年第一季度报告","time":"2018-04-26","pdf":"./report/20180426-3.pdf"},{"title":"[临时公告]旺翔数科:第一届监事会第十次会议决议公告","time":"2018-04-26","pdf":"./report/20180426-2.pdf"},{"title":"[临时公告]旺翔数科:第一届董事会第二十三次会议决议公告","time":"2018-04-26","pdf":"./report/20180426.pdf"},{"title":"[临时公告]旺翔数科:关于公司章程修订公告","time":"2018-04-17","pdf":"./report/20180417-6.pdf"},{"title":"[临时公告]旺翔数科:2017年年度股东大会通知公告","time":"2018-04-17","pdf":"./report/20180417-5.pdf"},{"title":"[临时公告]旺翔数科:第一届监事会第九次会议决议公告","time":"2018-04-17","pdf":"./report/20180417-4.pdf"},{"title":"[临时公告]旺翔数科:第一届董事会第二十二次会议决议公告","time":"2018-04-17","pdf":"./report/20180417-3.pdf"},{"title":"[定期报告]旺翔数科:2017年年度报告","time":"2018-04-17","pdf":"./report/20180417-2.pdf"},{"title":"[定期报告]旺翔数科:2017年年度报告摘要","time":"2018-04-17","pdf":"./report/20180417.pdf"},{"title":"[临时公告]旺翔数科:2018年第一次临时股东大会通知公告","time":"2018-04-12","pdf":"./report/20180412-3.pdf"},{"title":"[临时公告]旺翔数科:关联交易公告","time":"2018-04-12","pdf":"./report/20180412-2.pdf"},{"title":"[临时公告]旺翔数科:第一届董事会第二十一次会议决议公告","time":"2018-04-12","pdf":"./report/20180412.pdf"},{"title":"[临时公告]旺翔数科:2017年年度业绩预告公告","time":"2018-03-21","pdf":"./report/20180321-2.pdf"},{"title":"[临时公告]旺翔数科:2017年年度业绩快报公告","time":"2018-03-21","pdf":"./report/20180321.pdf"},{"title":"[临时公告]旺翔数科:2017年第五次临时股东大会决议公告","time":"2017-12-28","pdf":"./report/20171228.pdf"},{"title":"[临时公告]旺翔数科:2017年第五次临时股东大会通知公告","time":"2017-12-13","pdf":"./report/20171213.pdf"},{"title":"[[临时公告]旺翔数科:关于预计2018年度日常性关联交易的公告","time":"2017-12-13","pdf":"./report/20171213-2.pdf"},{"title":"[临时公告]旺翔数科:高级管理人员变动公告（任职情况）","time":"2017-12-13","pdf":"./report/20171213-3.pdf"},
            {
                title:'[临时公告]旺翔数科:第一届董事会第二十次会议决议公告',
                time:'2017-12-13',
                pdf:'./report/20171213-4.pdf'
            },
            {
                title:'[临时公告]旺翔数科:关于获评中国商报社“2017中国最具投资价值新三板公司100强”的公告',
                time:'2017-11-02',
                pdf:'./report/20171102.pdf'
            },
            {
                title:'[临时公告]旺翔数科:高级管理人员变动公告（辞职情况）',
                time:'2017-10-31',
                pdf:'./report/20171031.pdf'
            },
            {
                title:'[临时公告]旺翔数科:职工代表监事变动公告（任职情况）',
                time:'2017-10-31',
                pdf:'./report/20171031-2.pdf'
            },
            {
                title:'[临时公告]旺翔数科:2017年第一次职工代表大会决议公告',
                time:'2017-10-31',
                pdf:'./report/20171031-3.pdf'
            },
            {
                title:'[临时公告]旺翔数科:职工代表监事变动公告（辞职情况）',
                time:'2017-10-31',
                pdf:'./report/20171031-4.pdf'
            },
            {
                title:'[临时公告]旺翔数科:2017年第四次临时股东大会决议公告',
                time:'2017-10-16',
                pdf:'./report/20171016.pdf'
            },
            {
                title:'[临时公告]旺翔数科:2017年第四次临时股东大会通知公告',
                time:'2017-09-29',
                pdf:'./report/20170929.pdf'
            },
            {
                title:'[临时公告]旺翔数科:关联交易公告',
                time:'2017-09-29',
                pdf:'./report/20170929-2.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届董事会第十九次会议决议公告',
                time:'2017-09-29',
                pdf:'./report/20170929-3.pdf'
            },
            {
                title:'[临时公告]旺翔数科:关于获得中华人民共和国增值电信业务经营许可证的公告',
                time:'2017-09-13',
                pdf:'./report/20170913.pdf'
            },
            {
                title:'[临时公告]旺翔数科:公司章程',
                time:'2017-09-01',
                pdf:'./report/20170901.pdf'
            },
            {
                title:'[临时公告]旺翔数科:监事变动公告（任免情况）',
                time:'2017-09-01',
                pdf:'./report/20170901-2.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届监事会第八次会议决议公告',
                time:'2017-09-01',
                pdf:'./report/20170901-3.pdf'
            },
            {
                title:'[临时公告]旺翔数科:2017年第三次临时股东大会决议公告',
                time:'2017-09-01',
                pdf:'./report/20170901-4.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届监事会第七次会议决议公告',
                time:'2017-08-18',
                pdf:'./report/20170818.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届董事会第十八次会议决议公告',
                time:'2017-08-18',
                pdf:'./report/20170818-2.pdf'
            },
            {
                title:'[定期报告]旺翔数科:2017年半年度报告',
                time:'2017-08-18',
                pdf:'./report/20170818-3.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届监事会第六次会议决议公告',
                time:'2017-08-17',
                pdf:'./report/20170817.pdf'
            },
            {
                title:'[临时公告]旺翔数科:第一届董事会第十七次会议决议公告',
                time:'2017-08-17',
                pdf:'./report/20170817-2.pdf'
            },
            {
                title:'[临时公告]旺翔数科:2017年第三次临时股东大会通知公告',
                time:'2017-08-17',
                pdf:'./report/20170817-3.pdf'
            },
            {
                title:'[临时公告]旺翔数科:关联交易公告',
                time:'2017-08-17',
                pdf:'./report/20170817-4.pdf'
            },
            {
                title:'[临时公告]旺翔数科:监事变动公告（辞职情况）',
                time:'2017-08-16',
                pdf:'./report/20170816.pdf'
            },
        ]
      };
    },
    components: {  },
    mounted() {
        let arr = []
        for(let i of this.$refs.tt.children){
            let obj = {
                title:i.children[0].children[0].children[0].innerHTML,
                time:i.children[0].children[1].children[0].innerHTML,
                pdf:i.children[0].href
            }
            arr.push(obj)
        }
        // console.log(JSON.stringify(arr))
    },
    methods: {
        toSee(num){
            if(num == 1){
                this.dialogVisible = this.dialogVisible ? false :true
            }
            if(num == 2){
                this.dialogVisible1 = this.dialogVisible1 ? false :true
            }
            if(num == 3){
                this.dialogVisible2 = this.dialogVisible2 ? false :true
            }
        },
        handleClose(done){
            this.dialogVisible = false
            this.dialogVisible1= false
            this.dialogVisible2 = false
            done()
        },
        toNum(num){
            this.num = num
        },
        currentChange(i){
            this.num1 = i
        },
      toNum(num){
        this.num = num
      },
      toPath(path,target){
        if(!path){
          return
        }
        if(path.includes(this.OUT_URL)){
          window.open(path, '_blank');
        }else{
          this.$router.push({path:path,query: {}})
        }
      }
    },
  };
  </script>
  <style lang='less' src="./index.less"  >
  </style>